module.exports = __webpack_public_path__ + "assets/merriweather-regular.ffdfd6e373f434b231a6e0eed26cb5b2270b3bb66b2ce3b360ec833f1e7e005e.woff2";